/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Forward_Email_SubtitleInputs */

const en_mobile_forward_email_subtitle = /** @type {(inputs: Mobile_Forward_Email_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll turn emails and newsletters into audio`)
};

const es_mobile_forward_email_subtitle = /** @type {(inputs: Mobile_Forward_Email_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertiremos correos y newsletters en audio`)
};

/**
* | output |
* | --- |
* | "We'll turn emails and newsletters into audio" |
*
* @param {Mobile_Forward_Email_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_forward_email_subtitle = /** @type {((inputs?: Mobile_Forward_Email_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Forward_Email_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_forward_email_subtitle(inputs)
	return en_mobile_forward_email_subtitle(inputs)
});